import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  public Base_Url = environment['adminServerUrl'];
  public Bwt_Url = environment['bwtServerUrl'];
  public Bwt_staging_Url = environment['bwtstagingServerUrl'];
  public wallet_url = environment['walleturl'];
  public socketurl = environment["SOCKET_ENDPOINT"];
  private userBalanceSubjectName = new Subject<any>();
  private betStatus = new Subject<any>();
  userDetails: any;
  reqHeader: any;
  usertoken: any;

  constructor(private http: HttpClient) {
    // console.log(this.wallet_url)
  }
  setBearerToken() {
    this.userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
    //alert(JSON.stringify(this.userDetails));
    this.reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.userDetails?.verifytoken}`,
    });
  }

  set_form_token() {
    this.usertoken = this.userDetails.verifytoken;
    this.reqHeader = {
      headers: new HttpHeaders().set(
        "Authorization",
        "Bearer " + this.usertoken
      ),
    };
  }
  returnUserBalance() {
    return this.userBalanceSubjectName.asObservable();
  }
  returnBetStatus() {
    return this.betStatus.asObservable();
  }

  Get(action) {
    return this.http.get(this.Base_Url + action);
  }

  Post(Base_Url: any, data: any) {
    return this.http.post(Base_Url, data);
  }
  walletPost(url: any, data: any) {
    console.log(url)
    return this.http.post(this.wallet_url + url, data);
  }
  putwallet(url: any, data: any) {
    return this.http.put(this.wallet_url + url, data);
  }
  casioPost(url: any, data: any) {
    this.setBearerToken();
    //alert(JSON.stringify(url, data));
    return this.http.post(this.Base_Url + url, data, {
      headers: this.reqHeader,
    });
  }

  getdata(action) {
    return this.http.get(this.Bwt_Url + action);
  }


  postdata(Bwt_Url: any, data: any) {
    return this.http.post(this.Bwt_Url + Bwt_Url, data);
  }

  SocketPost(url: any, data: any) {
    this.setBearerToken();
    return this.http.post(this.socketurl + "user/" + url, data, {
      headers: this.reqHeader,
    });
  }
  SoPost(url: any, data: any) {
    this.setBearerToken();
    return this.http.post(this.socketurl + "user/" + url, data, {
      headers: this.reqHeader,
    });
  }

  postdatastaging(Bwt_Url: any, data: any) {
    return this.http.post(this.Bwt_staging_Url + Bwt_Url, data);
  }

  putdata(Bwt_Url: any, data: any) {
    return this.http.put(this.Bwt_Url + Bwt_Url, data);
  }


  post_api(Base_Url: any, data: any) {
    return this.http.post(this.Base_Url + Base_Url, data);
  }

  post_kapi(Base_Url: any, data: any) {
    return this.http.post(this.Bwt_Url + Base_Url, data);
  }


  updateUserBalanceSubject(data) {
    this.userBalanceSubjectName.next(data);
  }

  updateBetPlaced(data) {
    this.betStatus.next(data);
    // console.log( this.betStatus.next(data));
  }
}
